export const GET_MEMBER_DEFINITIONS = "GET_MEMBER_DEFINITIONS"
export const GET_MEMBER_DEFINITIONS_SUCCESS = "GET_MEMBER_DEFINITIONS_SUCCESS"

export const ADD_NEW_MEMBER_DEFINITION = "ADD_NEW_MEMBER_DEFINITION"
export const ADD_MEMBER_DEFINITION_SUCCESS = "ADD_MEMBER_DEFINITION_SUCCESS"

export const UPDATE_MEMBER_DEFINITION = "UPDATE_MEMBER_DEFINITION"
export const UPDATE_MEMBER_DEFINITION_SUCCESS = "UPDATE_MEMBER_DEFINITION_SUCCESS"

export const DELETE_MEMBER_DEFINITION = "DELETE_MEMBER_DEFINITION"
export const DELETE_MEMBER_DEFINITION_SUCCESS = "DELETE_MEMBER_DEFINITION_SUCCESS"

export const MEMBER_DEFINITION_API_ERROR = "MEMBER_DEFINITION_API_ERROR"